import { DateRangeValue } from '@/lib/helpers';
import { McpEntity } from '@/lib/models/policy-model/mcp-controls';
import { ProxyIpRangeConfig } from '@/lib/models/connector/proxy-connector.model';
import { PublicServiceConfig as PublicServiceConfigV1 } from '@/lib/models/policy-model-v1/public-services';
import { SensitiveDataEntity } from '@/lib/models/policy-model-v1/sensitive-data';
import { AnyObject, ObjectSchema } from 'yup';
import lodashGet from 'lodash/get';
import type { OnOffEntity } from '../on-off-list/helpers';
import { PublicServiceConfig } from '@/lib/models/policy-model/public-services';
import { McpControls as McpControlsV1 } from '@/lib/models/policy-model-v1';

export type InputControlType =
  | 'text'
  | 'regex'
  | 'text-hexadecimal'
  | 'password'
  | 'email'
  | 'url'
  | 'number'
  | 'checkbox'
  | 'date'
  | 'date-range'
  | 'textarea'
  | 'switch'
  | 'on-off-toggle-button'
  | 'select'
  | 'select-multi'
  | 'select-search'
  | 'text-multi'
  | 'list-toggle'
  | 'list-editor'
  | 'switch-list'
  | 'on-off-list'
  | 'public-service-acl'
  | 'new-services-list'
  | 'groups-list-toggle'
  | 'policy-public-action-select'
  | 'aws-region-select'
  | 'datadog-site-select'
  | 'sd-entity-list'
  | 'sd-action-select'
  | 'datasources-list-toggle'
  | 'agents-list-toggle'
  | 'proxy-auth-type-select'
  | 'proxy-ip-range-list-editor'
  | 'telemetry-type-select'
  | 'mcp-tools-acl'
  | 'mcp-tool-action-switch'
  | 'vertex-region-select'
  | 'public-service-acl-v1'
  | 'new-services-list-v1'
  | 'mcp-tools-acl-v1'
  | 'mcp-tool-action-switch-v1'
  | 'policy-public-action-select-v1'
  | 'sd-entity-list-v1'
  | 'sd-action-select-v1'
  | 'boolean-select';

export type InputControlValue =
  | null
  | undefined
  | string
  | number
  | boolean
  | Date
  | DateRangeValue
  | string[]
  | OnOffEntity<string>[]
  | SensitiveDataEntity[]
  | PublicServiceConfigV1
  | PublicServiceConfig
  | McpEntity[]
  | McpControlsV1
  | ProxyIpRangeConfig[];

// @todo typing?
export const getErrorText = (formikError: string | string[] | object | undefined): string => {
  if (!formikError) {
    return '';
  }

  // If the error is an object, it means there are nested errors.
  // The field itself doesn't have a direct error, so return empty string.
  // Nested errors should be displayed on their respective nested fields.
  if (typeof formikError === 'object' && !Array.isArray(formikError)) {
    return '';
  }

  if (Array.isArray(formikError)) {
    return formikError.join(', ');
  }

  // @todo handle more types?
  return String(formikError);
};

export const fieldIsRequired = (fieldName: string, validationSchema: ObjectSchema<AnyObject>) => {
  const field = lodashGet(validationSchema.fields, fieldName.replace(/\./, '.fields.'));

  if (!field) {
    return false;
  }

  // @todo oof
  /* eslint-disable */
  const isRequired = !!(field as any).tests.find((test: any) => test.OPTIONS.name === 'required');
  /* eslint-enable */

  return isRequired;
};
